import { default as Home } from './DashboardHome';
import { default as SessionGroup } from './SessionGroup';
export default {
	Home,
	SessionGroup
};
